import script from "./subjectsListSection.vue?vue&type=script&setup=true&lang=js"
export * from "./subjectsListSection.vue?vue&type=script&setup=true&lang=js"

import "./subjectsListSection.vue?vue&type=style&index=0&id=6b862bb4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b862bb4"]])

export default __exports__